// ADR-0006 D1, D2: trilingual types. `de` is a first-class locale, not a
// translation of English; the locale order is `de, hu, en` everywhere.

export const LOCALES = ["de", "hu", "en"] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

export type LocalizedText = Record<Locale, string>;
export type LocalizedList = Record<Locale, string[]>;
